import './App.css';
import { useEffect, useState } from "react";

import Home from './pages/home.pages';
import { Routes, Route } from "react-router-dom";
import Navigation from './components/navigation.components';
import Shop from './pages/shop.pages';
import Blog from './pages/blog.pages';
import Contact from './pages/contact.pages';

import Login from './components/login.components';
import WomenProduct from './pages/women-product.pages';
import MenProduct from './pages/men-product.pages';
import { Cart } from './components/cart.components';
import { Favourite } from './components/favourite.components';


function App() {
  const [first, setfirst] = useState(true);
  useEffect(() => {
    setfirst(false)
  }, [])


  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Navigation />} >
          <Route index element={first ? (<div id="preloder"><div className="loader"></div></div>): (<Home />)} />
          <Route path="shop" element={first ? (<div id="preloder"><div className="loader"></div></div>) :( <Shop />)} />
          <Route path="blog" element={first ? (<div id="preloder"><div className="loader"></div></div>) : (<Blog />)} />
          <Route path="contact" element={first ? (<div id="preloder"><div className="loader"></div></div>) : (<Contact />)} />
          <Route path="login" element={first ? (<div id="preloder"><div className="loader"></div></div>) : (<Login />)} />
          <Route path="women" element={first ? (<div id="preloder"><div className="loader"></div></div>) : (< WomenProduct/>)} />
          <Route path="men" element={first ? (<div id="preloder"><div className="loader"></div></div>) : (<MenProduct />)} />
          <Route path="cart" element={first ? (<div id="preloder"><div className="loader"></div></div>) : (<Cart />)} />
          <Route path="favourite" element={first ? (<div id="preloder"><div className="loader"></div></div>) : (<Favourite />)} />
        </Route>
      </Routes>

      {/* <Home/> */}
    </div>
  );
}

export default App;
